/** .alert-info / -warning / -success */
export default function Alert({ kind = 'info', className = '', children, ...rest }) {
  return <div className={['alert', `alert-${kind}`, className].filter(Boolean).join(' ')} {...rest}>{children}</div>;
}
